var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkActivityPreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8771_22997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.42188 33C3.08854 31.3333 6.32188 26.9 13.9219 22.5H148.922C150.755 23 155.222 25 158.422 29C161.622 33 162.089 35 161.922 35.5V42L159.922 49.5L156.922 53.5L151.922 57H145.422H139.922L137.922 52.5L133.922 46L129.422 40.5H57.4219H39.4219L48.4219 52.5V57H22.4219L12.9219 56L7.92188 53.5L4.92188 48.5L2.42188 42V33Z",
    fill: "#4938AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.373 58.864H139.146C136.619 58.864 136.619 55.024 139.146 55.024H146.373C153.893 55.024 159.999 48.9175 159.999 41.3978V37.3178C159.999 29.7981 153.893 23.6916 146.373 23.6916H17.4662C9.94656 23.6916 3.84 29.7981 3.84 37.3178V41.3978C3.84 48.9175 9.94656 55.024 17.4662 55.024H50.04C52.5706 55.024 52.5706 58.864 50.04 58.864H17.4662C7.83936 58.864 0 51.0237 0 41.3978V37.3178C0 27.6909 7.84032 19.8516 17.4662 19.8516H146.373C156 19.8516 163.839 27.6919 163.839 37.3178V41.3978C163.839 51.0247 155.999 58.864 146.373 58.864Z",
    fill: "#4938AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.427 42.2541H18.2417C15.7111 42.2541 15.7111 38.4141 18.2417 38.4141H145.427C147.955 38.4141 147.955 42.2541 145.427 42.2541Z",
    fill: "#7663EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.145 58.8656C138.057 58.8656 137.536 58.1898 137.225 57.2519C135.731 52.7322 131.345 42.2384 122.798 42.2384C120.27 42.2384 120.27 38.3984 122.798 38.3984C134.138 38.3984 139.029 50.9821 140.918 56.2256C141.419 57.6157 140.444 58.8656 139.145 58.8656Z",
    fill: "#7663EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.149 143.987H50.1354C49.0689 143.987 48.2154 143.12 48.2154 142.067V59.6541C48.2154 56.8941 48.2154 56.8941 47.0154 54.0937C45.1223 49.6672 40.882 42.2541 33.7885 42.2541C31.258 42.2541 31.258 38.4141 33.7885 38.4141C40.6823 38.4141 46.6285 43.4406 50.5482 52.5875C52.1274 56.2672 52.0545 56.6166 52.0545 60.1744V140.147H137.228V56.9478C137.228 54.4201 141.068 54.4201 141.068 56.9478V142.067C141.068 143.134 140.201 143.987 139.148 143.987H139.149Z",
    fill: "#7663EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9228 83.8369C61.3366 83.8369 56.7891 79.2903 56.7891 73.7041C56.7891 68.1178 61.3356 63.5703 66.9228 63.5703C76.1628 63.5703 79.6611 75.6241 75.1366 75.6241C74.07 75.6241 73.2166 74.7706 73.2166 73.7041C73.2166 65.4231 60.63 65.4231 60.63 73.7041C60.63 77.1706 63.4563 79.9978 66.9238 79.9978C69.4543 79.9978 69.4543 83.8378 66.9238 83.8378L66.9228 83.8369Z",
    fill: "#7663EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9225 100.252C57.6777 100.252 54.19 88.1981 58.7087 88.1981C59.7753 88.1981 60.6287 89.065 60.6287 90.1181C60.6287 98.3991 73.2153 98.3991 73.2153 90.1181C73.2153 86.6516 70.3891 83.8244 66.9215 83.8244C64.391 83.8244 64.391 79.9844 66.9215 79.9844C72.5078 79.9844 77.0553 84.5309 77.0553 90.1172C77.0553 95.7034 72.5087 100.251 66.9215 100.251L66.9225 100.252Z",
    fill: "#7663EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.572 94.3713H86.9717C84.4469 94.3713 84.4469 90.5312 86.9717 90.5312H130.572C133.097 90.5312 133.097 94.3713 130.572 94.3713Z",
    fill: "#7663EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.574 83.84H86.9739C84.4462 83.84 84.4462 80 86.9739 80H130.574C133.102 80 133.102 83.84 130.574 83.84Z",
    fill: "#7663EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.57 73.3009H108.771C106.243 73.3009 106.243 69.4609 108.771 69.4609H130.57C133.098 69.4609 133.098 73.3009 130.57 73.3009Z",
    fill: "#7663EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.122 116.621H62.1614C59.6337 116.621 59.6337 112.781 62.1614 112.781H127.107C129.628 112.781 129.633 116.621 127.121 116.621H127.122Z",
    fill: "#7663EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.734 129.731H78.5481C76.0204 129.731 76.0204 125.891 78.5481 125.891H110.747C113.27 125.891 113.28 129.731 110.734 129.731Z",
    fill: "#7663EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9201 67.4064C64.3118 67.4064 65.0001 63.8025 65.0001 60.5932C65.0001 58.0627 68.8401 58.0627 68.8401 60.5932C68.8401 63.8035 69.5284 67.4064 66.9201 67.4064Z",
    fill: "#7663EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9201 105.154C64.3118 105.154 65.0001 101.526 65.0001 98.3411C65.0001 95.8134 68.8401 95.8134 68.8401 98.3411C68.8401 101.526 69.5284 105.154 66.9201 105.154Z",
    fill: "#7663EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8771_22997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163.839,
    height: 163.839,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkActivityPreview);
export default __webpack_public_path__ + "static/media/work-activity-preview.504e364fd6a65b9efbd32f0df5e16e50.svg";
export { ForwardRef as ReactComponent };